var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_group",
    "data-name": "icon group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M16.5,12.5h-4v4h4Zm-4-1.5h4A1.5,1.5,0,0,1,18,12.5v4A1.5,1.5,0,0,1,16.5,18h-4A1.5,1.5,0,0,1,11,16.5v-4A1.5,1.5,0,0,1,12.5,11Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M7.5,3.5h-4v4h4Zm9,0h-4v4h4Zm-9,9h-4v4h4ZM7.5,2h-4A1.5,1.5,0,0,0,2,3.5v4A1.5,1.5,0,0,0,3.5,9h4A1.5,1.5,0,0,0,9,7.5v-4A1.5,1.5,0,0,0,7.5,2Zm9,0h-4A1.5,1.5,0,0,0,11,3.5v4A1.5,1.5,0,0,0,12.5,9h4A1.5,1.5,0,0,0,18,7.5v-4A1.5,1.5,0,0,0,16.5,2Zm-13,9h4A1.5,1.5,0,0,1,9,12.5v4A1.5,1.5,0,0,1,7.5,18h-4A1.5,1.5,0,0,1,2,16.5v-4A1.5,1.5,0,0,1,3.5,11Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.7a989543ee8027b04ac16123d209e88a.svg";
export { ForwardRef as ReactComponent };